var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      model: {
        value: _vm.valid,
        callback: function($$v) {
          _vm.valid = $$v
        },
        expression: "valid"
      }
    },
    [
      _c("v-textarea", {
        attrs: {
          rules: _vm.rules,
          counter: _vm.maxCharacters,
          loading: _vm.loader,
          label: "Biografia",
          placeholder: "Insira uma biografia para o profissional...",
          "auto-grow": ""
        },
        model: {
          value: _vm.biography,
          callback: function($$v) {
            _vm.biography = $$v
          },
          expression: "biography"
        }
      }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "justify-end": "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "mr-0",
              attrs: {
                color: "primary",
                disabled: !_vm.valid,
                loading: _vm.loader
              },
              on: { click: _vm.save }
            },
            [_vm._v("salvar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c50d7c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c50d7c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals/Edit/Tabs/Biography.vue
// module id = null
// module chunks = 